import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form, Input, Button, Modal } from "antd";
import LoginSide from "../../../assets/images/login.svg";
import logoSmall from "../../../assets/images/logo/logo.svg";
import { UserLogout } from '../../../redux/Login/LoginActions';
import { checkResetPasswordLink, resetPassword } from '../../../redux/UserMaster/UserMasterAction';
import { Redirect } from "react-router-dom";

export default function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [showMsg, setShowMSg] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const formRef = useRef();

  useEffect(async () => {
    await UserLogout();
    const searchLocation = window.location.search;
    const searchParams = new URLSearchParams(searchLocation);
    var email = searchParams.get('mail');
    var token = searchParams.get('token');

    var result = await checkResetPasswordLink({ email: email, token: token });

    if (result.result) {
      formRef.current?.setFieldsValue({ email: email, token: token });
    }
    else {
      Modal.error({ title: result.message });
      setRedirect(true);
    }
  }, [1])

  const handleResetPassword = async () => {
    var values = await formRef.current?.getFieldsValue();

    if (values.password != values.confirmPassword) {
      formRef.current?.setFieldsValue({ password: "", confirmPassword: "" })
      return Modal.error({ content: "Passwords do not match." });
    }

    setLoading(true)
    var result = await resetPassword(values);
    setLoading(false);

    if (result.result) {
      Modal.success({ title: "You have successfully reset your password, please login...!" });
      setRedirect(true);
    }
    else {
      Modal.error({ title: result.message });
      setRedirect(true);
    }
  }

  if (redirect) {
    return (<Redirect to="/login" />)
  }

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" align="middle" justify="center">
          <Col xxl={11} xl={15} lg={20} md={20} sm={24} className="hp-px-sm-8 hp-pt-24 hp-pb-48 hp-text-center">
            <img src={logoSmall} alt="Logo" width="180" class="hp-mb-24 " />
            <h2 className="hp-mb-sm-0 hp-text-color-primary-1 hp-text-color-dark-0 hp-text-center">Budy Professional Services</h2>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60 hp-text-center">Very good works are  waiting for you 🤞</p>
            <Form ref={formRef} onFinish={() => handleResetPassword()} layout="vertical" name="basic" className="hp-mt-sm-16 hp-mt-32" >
              <Form.Item name="email" className="hp-mb-16" hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item name="token" className="hp-mb-16" hidden={true}>
                <Input />
              </Form.Item>
              <Form.Item name="password" label="New Password:" className="hp-mb-16" rules={[{ required: true, message: "Required" }]}>
                <Input.Password placeholder="Enter New Password" />
              </Form.Item>
              <Form.Item name="confirmPassword" label="Confirm Password:" className="hp-mb-16" rules={[{ required: true, message: "Required" }]}>
                <Input.Password placeholder="Enter Confirm Password" />
              </Form.Item>
              <Button loading={loading} htmlType="submit" block type="primary">Reset Password</Button>
            </Form>
          </Col>
        </Row>
      </Col>

      <Col lg={12} span={24} className="hp-bg-color-primary-4 hp-bg-color-dark-90 hp-position-relative">
        <Row className="hp-image-row hp-h-100 hp-px-sm-8 hp-px-md-16 hp-pb-sm-32 hp-pt-md-96 hp-pt-md-32">
          <Col span={24}>
            <Row align="middle" justify="center" className="hp-h-100">
              <Col md={20} span={24} className="hp-bg-item hp-text-center hp-mb-md-32">
                <img src={LoginSide} alt="Logo" width="900" className=" hp-position-relative" style={{ zIndex: "999" }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};